export const MILK_SOLD_PAGE_SIZE_OPTIONS = [20, 50];
export const DEFAULT_MILK_SOLD_PAGE_SIZE = 20;

export const getMilkSoldTotalPages = (items, pageSize = DEFAULT_MILK_SOLD_PAGE_SIZE) => {
  const totalItems = Array.isArray(items) ? items.length : 0;
  if (pageSize <= 0) return 1;
  return Math.max(1, Math.ceil(totalItems / pageSize));
};

export const paginateMilkSoldItems = (
  items,
  page,
  pageSize = DEFAULT_MILK_SOLD_PAGE_SIZE
) => {
  if (!Array.isArray(items) || pageSize <= 0) return [];
  const totalPages = getMilkSoldTotalPages(items, pageSize);
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * pageSize;
  return items.slice(start, start + pageSize);
};

export const milkSoldRangeForPage = (items, page, pageSize = DEFAULT_MILK_SOLD_PAGE_SIZE) => {
  if (!Array.isArray(items) || items.length === 0 || pageSize <= 0) {
    return { start: 0, end: 0 };
  }
  const totalPages = getMilkSoldTotalPages(items, pageSize);
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * pageSize + 1;
  const end = Math.min(safePage * pageSize, items.length);
  return { start, end };
};

export const buildMilkSoldChartData = (sales) => {
  const safeSales = Array.isArray(sales) ? sales : [];
  const litersByClientMap = new Map();
  const paymentModeMap = new Map();
  const unitPriceMap = new Map();

  safeSales.forEach((sale) => {
    const clientName = sale.clientName?.trim() || "Unknown Client";
    const liters = parseFloat(sale.quantity ?? sale.liters ?? 0) || 0;
    const paymentMode = (sale.paymentMode ?? sale.PaymentMode ?? "").trim() || "Unspecified";
    const unitPriceValue = parseFloat(sale.unitPrice ?? sale.UnitPrice ?? 0) || 0;
    const unitPrice = unitPriceValue > 0 ? `KES ${unitPriceValue.toFixed(2)}` : "Unspecified";

    litersByClientMap.set(clientName, (litersByClientMap.get(clientName) || 0) + liters);
    paymentModeMap.set(paymentMode, (paymentModeMap.get(paymentMode) || 0) + 1);
    unitPriceMap.set(unitPrice, (unitPriceMap.get(unitPrice) || 0) + 1);
  });

  const sortByValueDesc = (a, b) => b.value - a.value;

  return {
    litersByClient: Array.from(litersByClientMap, ([client, liters]) => ({
      client,
      liters: Number(liters.toFixed(2)),
    })).sort((a, b) => b.liters - a.liters),
    paymentModeDistribution: Array.from(paymentModeMap, ([name, value]) => ({
      name,
      value,
    })).sort(sortByValueDesc),
    unitPriceDistribution: Array.from(unitPriceMap, ([name, value]) => ({
      name,
      value,
    })).sort(sortByValueDesc),
  };
};
